import { render } from "./InputSenha.vue?vue&type=template&id=d5222caa"
import script from "./InputSenha.vue?vue&type=script&lang=js"
export * from "./InputSenha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__